<script setup lang="ts">

import dayjs from "dayjs";
import { ref } from "vue";
import type { ConfigureConditionViewModel } from "..";

const model = defineModel<ConfigureConditionViewModel>( { required: true } );
const selection = ref();

const options = [
    { value: 1, name: 'Next week' },
    { value: 2, name: 'In 2 weeks' },
    { value: 4, name: 'In 4 weeks' },
    { value: 6, name: 'In 6 weeks' },
    { value: 8, name: 'In 2 months' },
    { value: 12, name: 'In 3 months' }
];

/**
 * Occurs when the user selects a week
 * @param weeks 
 */
async function onSelected( weeks: number )
{
    selection.value = weeks;
    const date = dayjs().add( weeks, 'week' );
    await model.value.onSelectNext( date, weeks );
}

</script>

<template>

    <div class="text-base text-center flex flex-col pb-10 tracking-widest">

        <h1 class="leading-tight my-6 px-4 lg:px-8">
            When would you like to be reminded?
        </h1>

        <div class="grid grid-cols-1 ">
            <template v-for="(option,index) in options">
                <button class="flex items-center 
                             even:bg-black/[2%] dark:even:bg-white/[2%]
                               py-3 text-base lg:text-lg"
                        @click="() => onSelected( option.value )">

                    <div class="pl-4">
                        <Icon name="calendar" class="text-3xl opacity-60" />
                    </div>

                    <div class="flex-1 flex items-center tracking-wider px-4">
                        {{ option.name }}
                    </div>
                    <div class="flex justify-center px-4">
                        <CheckBox v-model="selection" 
                                  :value="option.value"
                                  color="white"
                                  class="flex-none" />
                    </div>
                </button>
            </template>
        </div>

    </div>

</template>